import { recordFirstInteraction } from '@achieve/cx-event-horizon/browser'
import { isEhConsentTealiumEnabled } from './ehConsentTealiumEnabled'

/** @param {'banner_ok' | 'banner_close'} source */
export function recordBannerEhConsent(source, analytics) {
  if (!isEhConsentTealiumEnabled()) return
  recordFirstInteraction(source, { analytics })
}
